﻿$.fn.dxCtrlBuilderEmailStyleFontBold = function custom_dxCtrlBuilderEmailStyleFontBold (option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylefontbold dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleFontBold (this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleFontBold = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;padding-right:5px;vertical-align:middle;'><i class='fas fa-bold' style='font-size:16px'></i></td>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Table)
        var ds = ["Léger", "Normal", "Gras", "SurGras"]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo($Td).dxCtrlRadioButton({
            dataSource: ds,
            value: ((option.value == "lighter") ? "Léger" : ((option.value == "normal") ? "Normal" : ((option.value == "bold") ? "Gras" : ((option.value == "bolder") ? "SurGras" : "Défaut")))),
            layout: 'horizontal',
            itemTemplate: function (itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                var newValue = ""
                switch (e.value) {
                    case "Défaut": newValue = ""; break;
                    case "Léger": newValue = "lighter"; break;
                    case "Normal": newValue = "normal"; break;
                    case "Gras": newValue = "bold"; break;
                    case "SurGras": newValue = "bolder"; break;
                }
                option.onValueChanged({ values: [{ prop: "font-weight", value: newValue, oldValue: option.value }] })
                option.value=newValue
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}